import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Select from 'react-select'
import { setAdvance, setBooking, setDelivery, setPickup, setStep } from "../../../Reducer/bookingSlice";
import NextPrev from "../../../Helpers/Components/NextPrev";
import { toast } from "react-toastify";
import Handler from "../../../Helpers/Components/Handler";

const Payment = (props) => {
    const dispatch = useDispatch()
    const booking = useSelector(state => state?.booking?.booking)
    const [loading, setLoading] = useState(false)
    const setSteps = () => {
        dispatch(setStep(1))
    }
    const handleChange = (e) => {
        dispatch(setBooking({ [e.target.name]: e.target.value }))
    }
    const handleNext = async () => {
        let bal = Number(booking?.balancePaid || 0) + Number(booking?.advance?.amount || 0);
        let balance = booking?.balance?.length ? booking?.balance?.reduce((total, num) => total + Number(num?.amount), 0) : 0
        if ((!booking?.rentalFee || Number(booking?.rentalFee) <= 0)) {
            toast.error("Cost per day is required");
        } else if ((Number(booking?.offerPerDay) < 0)) {
            toast.error("Invalid Offer per day");
        } else if (((Number(booking?.rentalFee || 0) - Number(booking?.offerPerDay || 0)) * booking?.totalDays) <= 0) {
            toast.error("Invalid Offer given");
        } else if (Number(booking?.rentalFee || 0) / 2 < Number(booking?.halfDayOffer)) {
            toast.error("Half day offer is invalid")
        } else if ((Number(booking?.deliveryDetails?.price) < 0)) {
            toast.error("Invalid Delivery Charge");
        } else if ((Number(booking?.pickupDetails?.price) < 0)) {
            toast.error("Invalid Pickup Charge");
        } else if ((Number(booking?.securityDeposit) < 0)) {
            toast.error("Invalid Security Deposit");
        } else if (!Number(booking?.advance?.amount) || (Number(booking?.advance?.amount) <= 0)) {
            toast.error("Invalid Advance Paid");
        } else if ((!booking?.advance?.mode)) {
            toast.error("Advance paid mode is required");
        } else if ((Number(bal) < Number(booking?.advance?.amount || 0))) {
            toast.error("Advance paid should be less than balance to be paid");
        } else if (Number(booking?.balancePaid) !== Number(balance)) {
            toast.error("Balance paid is wrong");
        } else {
            let balanceCheck = booking?.balance?.length ? booking?.balance?.filter(element => !element?.amount || !element?.mode || !element?.remarks)?.length : false
            if (balanceCheck) {
                toast.error("Please all balance details properly")
            } else {
                const data = {
                    rentalFee: Number(booking?.rentalFee) || 0,
                    offerPerDay: Number(booking?.offerPerDay) || 0,
                    halfDayOffer: booking?.point === 0.5 ? booking?.halfDayOffer : 0,
                    securityDeposit: booking?.securityDeposit || 0,
                    deliveryDetails: { price: booking?.deliveryDetails?.price || 0 },
                    pickupDetails: { price: booking?.pickupDetails?.price || 0 },
                    advance: booking?.advance,
                    balance: booking?.balance || []
                }
                setLoading(true);
                const response = await Handler({ method: 'patch', url: `/booking/close/third/update/${props?.bookingId}`, data })
                setLoading(false)
                if (response?.success) {
                    dispatch(setStep(3))
                } else {
                    toast.error(response?.message)
                }
            }
        }
    }
    const handleBalance = (value, name, index) => {
        const balance = Array.isArray(booking?.balance)
            ? booking.balance.map((element, i) =>
                i === index
                    ? { ...element, [name]: value }
                    : element
            )
            : [{ [name]: value }];

        dispatch(setBooking({ balance }));
    };
    useEffect(() => {
        let difference = Number(props?.prev?.pickup || 0) >= Number(booking?.pickupDetails?.price || 0) ? (Number(props?.prev?.pickup || 0) - Number(booking?.pickupDetails?.price || 0)) : (Number(booking?.pickupDetails?.price || 0) - Number(props?.prev?.pickup || 0))
        let final = Number(props?.prev?.pickup || 0) >= Number(booking?.pickupDetails?.price || 0) ? Number(props?.prev?.securityDeposit || 0) + difference : Number(props?.prev?.securityDeposit || 0) - difference
        dispatch(setBooking({ securityDeposit: final }))
    }, [booking?.pickupDetails?.price])
    useEffect(() => {
        let totalAmount =
            ((Number(booking?.rentalFee || 0) -
                Number(booking?.offerPerDay || 0)) * (booking?.totalDays || 0)) +
            Number(booking?.deliveryDetails?.price || 0) + Number(booking?.pickupDetails?.price || 0) +
            Number(booking?.securityDeposit || 0)
        totalAmount += Number(booking?.point) === 0.5 ? (Number(booking?.rentalFee || 0) / 2) - Number(booking?.halfDayOffer || 0) : 0
        dispatch(setBooking({ balancePaid: totalAmount - Number(booking?.advance?.amount || 0), totalAmount }));
    }, [booking?.rentalFee, booking?.offerPerDay, booking?.totalDays, booking?.deliveryDetails, booking?.securityDeposit, booking?.point, booking?.halfDayOffer, booking?.advance, booking?.balance]);

    return (
        <React.Fragment>
            <div className="fw-bold mb-3 text-center">{Number(booking?.totalDays || 0) + Number(booking?.point || 0)} Day Trip</div>
            {
                booking?.point === 0.5 ?
                    <div className="row">
                        <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                            <div className="mb-3">
                                <label htmlFor="halfDayOffer" className="form-label"> Half Day Offer </label>
                                <input readOnly name="halfDayOffer" id="halfDayOffer" autoComplete="off" disabled className="form-control input-theme text-uppercase" value={booking?.halfDayOffer || ""} />
                            </div>
                        </div>
                        <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                            <div className="mb-3">
                                <label htmlFor="halfRent" className="form-label"> Half Day Rent </label>
                                <input name="halfRent" id="halfRent" autoComplete="off" disabled className="form-control input-theme text-uppercase" value={booking?.rentalFee ? (Number(booking?.rentalFee) / 2) - Number(booking?.halfDayOffer || 0) : ""} />
                            </div>
                        </div>
                    </div> : ""
            }
            <div className="row">
                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                    <div className="mb-3">
                        <label htmlFor="rentalFee" className="form-label"> Cost Per Day </label>
                        <input name="rentalFee" id="rentalFee" autoComplete="off" disabled className="form-control input-theme text-uppercase" value={booking?.rentalFee || ""} />
                    </div>
                </div>
                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                    <div className="mb-3">
                        <label htmlFor="offerPerDay" className="form-label"> Offer Per Day </label>
                        <input readOnly name="offerPerDay" id="offerPerDay" autoComplete="off" disabled className="form-control input-theme text-uppercase" value={booking?.offerPerDay || ""} />
                    </div>
                </div>
                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                    <div className="mb-3">
                        <label htmlFor="totalCost" className="form-label"> Per Day Cost </label>
                        <input name="totalCost" id="totalCost" autoComplete="off" disabled className="form-control input-theme text-uppercase" value={((Number(booking?.rentalFee || 0) - Number(booking?.offerPerDay || 0)))} />
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                    <div className="mb-3">
                        <label htmlFor="dprice" className="form-label"> Delivery Charge </label>
                        <input readOnly name="dprice" id="dprice" autoComplete="off" disabled className="form-control input-theme text-uppercase" value={booking?.deliveryDetails?.price || ""} />
                    </div>
                </div>
                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                    <div className="mb-3">
                        <label htmlFor="pprice" className="form-label"> Pickup Charge </label>
                        <input onChange={(e) => { if (/^\d{0,}$/.test(e.target.value)) { dispatch(setPickup({ price: e.target.value })) } }} name="pprice" id="pprice" autoComplete="off" disabled={loading} className="form-control input-theme text-uppercase" value={booking?.pickupDetails?.price || ""} />
                    </div>
                </div>

                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                    <div className="mb-3">
                        <label htmlFor="pprice" className="form-label"> Total Rent </label>
                        <input readOnly name="pprice" id="pprice" autoComplete="off" disabled={true} className="form-control input-theme text-uppercase" value={(Number(Number(booking?.totalDays || 0) * (Number(booking?.rentalFee || 0) - Number(booking?.offerPerDay || 0))) + (booking?.point === 0.5 ? Number((Number(booking?.rentalFee || 0) / 2) - (Number(booking?.halfDayOffer || 0))) : 0))} />
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                    <div className="mb-3">
                        <label htmlFor="securityDeposit" className="form-label"> Security Deposit </label>
                        <input readOnly name="securityDeposit" id="securityDeposit" autoComplete="off" disabled className="form-control input-theme text-uppercase" value={booking?.securityDeposit || ""} />
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                    <div className="mb-3">
                        <label htmlFor="advAmount" className="form-label"> Advance Paid </label>
                        <input readOnly name="advAmount" id="advAmount" autoComplete="off" disabled className="form-control input-theme text-uppercase" value={booking?.advance?.amount || ""} />
                    </div>
                </div>
                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                    <div className="mb-3">
                        <label htmlFor="carId" className="form-label"> Advance Paid Mode </label>
                        <Select
                            styles={{
                                control: (base, state) => ({
                                    ...base,
                                    borderColor: state.isFocused ? "#f16436" : base.borderColor,
                                    boxShadow: state.isFocused ? "0 0 0 1px #f16436" : "none",
                                    "&:hover": {
                                        borderColor: "#f16436"
                                    }
                                }),
                                option: (style, state) => ({
                                    ...style,
                                    backgroundColor: state.isSelected
                                        ? "#f16436"
                                        : (state.isFocused || state.isActive)
                                            ? "#f164361a"
                                            : "white",
                                    color: state.isSelected ? "white" : "black"
                                })
                            }}
                            isDisabled

                            options={[
                                { value: "UPI", label: "UPI" },
                                { value: "Cash", label: "Cash" },
                                { value: "Net Banking", label: "Net Banking" }
                            ]}
                            value={booking?.advance?.mode ? { label: booking?.advance?.mode, value: booking?.advance?.mode } : {}}
                        />
                    </div>
                </div>
                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                    <div className="mb-3">
                        <label htmlFor="advRemarks" className="form-label"> Advance Paid Remarks </label>
                        <input readOnly name="advRemarks" id="advRemarks" autoComplete="off" disabled className="form-control input-theme text-uppercase" value={booking?.advance?.remarks || ""} />
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                    <div className="mb-3">
                        <label htmlFor="balance" className="form-label"> Balance to be Paid </label>
                        <input name="balance" id="balance" autoComplete="off" disabled className="form-control input-theme text-uppercase" value={booking?.balancePaid || 0} />
                    </div>
                </div>
            </div>
            {
                booking?.balance?.length ? booking?.balance?.map((element, i) => {
                    return (
                        <div className="row" key={i}>
                            <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                                <div className="mb-3">
                                    <label htmlFor={`balanceAmount${i}`} className="form-label"> Balance Amount {i + 1} </label>
                                    <input name={`balanceAmount${i}`} id={`balanceAmount${i}`} autoComplete="off" onChange={(e) => { if (/^\d{0,}$/.test(e.target.value)) { handleBalance(e?.target?.value, "amount", i) } }} disabled={loading} className="form-control input-theme text-uppercase" value={element?.amount || ""} />
                                </div>
                            </div>
                            <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                                <div className="mb-3">
                                    <label htmlFor={`balanceAmount${i}`} className="form-label"> Balance Amount {i + 1} Pay Mode </label>
                                    <Select
                                        styles={{
                                            control: (base, state) => ({
                                                ...base,
                                                borderColor: state.isFocused ? "#f16436" : base.borderColor,
                                                boxShadow: state.isFocused ? "0 0 0 1px #f16436" : "none",
                                                "&:hover": {
                                                    borderColor: "#f16436"
                                                }
                                            }),
                                            option: (style, state) => ({
                                                ...style,
                                                backgroundColor: state.isSelected
                                                    ? "#f16436"
                                                    : (state.isFocused || state.isActive)
                                                        ? "#f164361a"
                                                        : "white",
                                                color: state.isSelected ? "white" : "black"
                                            })
                                        }}
                                        onChange={(selectedOption) => {
                                            handleBalance(selectedOption.value, "mode", i)
                                        }}
                                        isDisabled={loading}
                                        options={[
                                            { value: "UPI", label: "UPI" },
                                            { value: "Cash", label: "Cash" },
                                            { value: "Net Banking", label: "Net Banking" }
                                        ]}
                                        value={booking?.balance?.length >= i ? { label: booking?.balance[i]?.mode, value: booking?.balance[i]?.mode } : {}}
                                    />
                                </div>
                            </div>
                            <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                                <div className="mb-3">
                                    <label htmlFor={`balanceAmount${i}`} className="form-label"> Balance Amount {i + 1} Remarks </label>
                                    <input name={`balanceAmount${i}`} id={`balanceAmount${i}`} onChange={(e) => handleBalance(e.target.value, "remarks", i)} autoComplete="off" disabled={loading} className="form-control input-theme text-uppercase" value={element?.remarks || ""} />
                                </div>
                            </div>
                        </div>
                    )
                })
                    : ""
            }
            {
                booking?.balancePaid > 0 && (booking?.balancePaid > (booking?.balance?.length ? booking?.balance?.reduce((total, num) => total + Number(num?.amount), 0) : 0))
                    ?
                    <i className="fa-solid fa-plus cursor-pointer mb-3 fs-4" onClick={() => {
                        let balance = booking?.balance?.length ? booking?.balance?.filter(element => !element?.amount || !element?.mode || !element?.remarks)?.length : false
                        if (balance) {
                            toast.error("Please fill above balance properly")
                        } else {
                            const value = Array.isArray(booking?.balance) ? booking.balance : [];
                            const updatedValue = [...value, { mode: "", amount: "", remarks: "" }];
                            dispatch(setBooking({ balance: updatedValue }));
                        }
                    }}></i>
                    : ""
            }
            <div className="row">
                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                    <div className="mb-3">
                        <label htmlFor="carId" className="form-label"> Final Amount </label>
                        <input onChange={(e) => { if (/^\d{0,}$/.test(e.target.value)) { handleChange(e) } }} name="location" id="location" autoComplete="off" disabled className="form-control input-theme text-uppercase" value={booking?.totalAmount || 0} />
                    </div>
                </div>
            </div>
            <NextPrev step={2} setStep={setSteps} last={4} onClick={handleNext} loading={false} />
        </React.Fragment>
    )
}

export default Payment